import { render, staticRenderFns } from "./MaterialSelect.vue.js?vue&type=template&id=5ef12ade&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MaterialSelect.vue?vue&type=template&id=5ef12ade&scoped=true"
import script from "./MaterialSelect.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MaterialSelect.vue?vue&type=script&lang=js"
export * from "./MaterialSelect.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MaterialSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef12ade",
  null
  
)

export default component.exports